import { Component, OnInit } from '@angular/core';

declare var VERSAO_SISTEMA: string;

@Component({
  selector: 'app-rodape',
  templateUrl: './rodape.component.html',
  styleUrls: ['./rodape.component.css']
})
export class RodapeComponent implements OnInit {


  version: string = 'Versão: ' + VERSAO_SISTEMA;
  constructor() { }

  ngOnInit() {
  }

}
